export default function SuccessScreen({
    title = "Success",
    caption,
    onPrimary,
    onSecondary
}: {
    title?: string;
    caption?: string;
    onPrimary: () => void;       // «Сканировать следующего»
    onSecondary?: () => void;    // «Назад» (опц.)
}) {
    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center px-5">
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
            <div className="relative z-10 w-full max-w-[420px] rounded-3xl border border-white/10 bg-white/80 p-6 text-neutral-900 shadow-xl">
                {/* простая иллюстрация-лайнарт */}
                <div className="mx-auto mb-4 grid h-28 w-28 place-items-center rounded-full bg-gradient-to-br from-pink-200 to-indigo-200 shadow-inner">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="url(#g)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <defs>
                            <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#ef4444"/>
                                <stop offset="100%" stopColor="#6366f1"/>
                            </linearGradient>
                        </defs>
                        <path d="M3 12h18M5 12l3 8h8l3-8M7 12l2-6h6l2 6" />
                        <path d="M9 16l2 2 4-4" />
                    </svg>
                </div>

                <h2 className="text-center text-xl font-bold">{title}</h2>
                {caption && <p className="mt-1 text-center text-sm text-neutral-600">{caption}</p>}

                <div className="mt-6 grid gap-2">
                    <button
                        onClick={onPrimary}
                        className="rounded-2xl bg-rose-500 px-5 py-3 text-base font-semibold text-white shadow active:translate-y-[1px]"
                    >
                        Сканировать следующего
                    </button>
                    <button
                        onClick={onSecondary}
                        className="rounded-2xl border border-neutral-300 px-5 py-3 text-sm font-medium text-neutral-700"
                    >
                        Вернуться
                    </button>
                </div>
            </div>
        </div>
    );
}